<template>
  <div
    class="tables-settings layout"
    :class="{
      empty: isEmpty,
    }"
  >
    <div class="layout-title">Настройки</div>

    <div class="tables-settings__tabs">
      <c-tabs
        :items="[
          {
            label: 'Общие настройки',
            value: '/index.php?r=total-settings%2Findex',
            link: '/index.php?r=total-settings%2Findex',
          },
          { label: 'Настройки таблиц', value: 'tables-settings', disabled: !userHavePermissionForTablesSettings },
          { label: 'Автоматическое создание ведомостей', value: 'auto-creation-calc-sheets', disabled: !userHavePermissionForAutoCreationCalcSheets },
        ]"
        with-routing
      />
    </div>

    <div class="tables-settings__content">
      <div v-if="inited" class="row tables-settings__actions">
        <div class="col col-12 col-md-8 col-lg-6 tables-settings__search">
          <c-input
            v-if="!isEmpty"
            v-model="query"
            placeholder="Поиск"
            type="text"
            :clearable="true"
            icon="search"
            @enter="applyFilters"
          />
        </div>

        <div class="col col-12 col-md-4 col-lg-6 tables-settings__add">
          <c-button
            label="Добавить настройку"
            :icon="{
              icon: 'plus',
              color: 'blue',
            }"
            @click="addTableSettings"
          />
        </div>
      </div>

      <div class="tables-settings__list">
        <tables-settings-table
          :inited="inited"
          :items="items"
          :empty="isEmpty"
          :sort-by="sortBy"
          :loading="loading"
          @nextPage="nextPage"
          @sort="sort"
          @remove="removeTableSettings"
        />
      </div>
    </div>

    <top-button root=".layout"></top-button>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import CTabs from "@/components/tabs";
import CButton from "@/components/controls/button";
import CInput from "@/components/controls2/Input";
import TopButton from "@/components/top-button";

import TablesSettingsTable from "./components/tables-settings-table";

export default {
  name: "tables-settings-list",

  components: {
    CTabs,
    CButton,
    CInput,
    TopButton,

    TablesSettingsTable,
  },

  computed: {
    ...mapGetters(["getUserPermissions"]),
    userHavePermissionForAutoCreationCalcSheets() {
      return this.getUserPermissions.includes("automaticCalculationSheetControl")
    },
    userHavePermissionForTablesSettings() {
      return this.getUserPermissions.includes("columnSettingsControl")
    },
  },

  data() {
    return {
      page: 1,
      query: "",
      sortBy: "",
      desc: false,
      items: [],
      isEmpty: false,
      isLastRequestEmpty: false,
      loading: false,
      inited: false,
    };
  },
  created() {
    this.getList().then(() => {
      this.isEmpty = !this.items.length;
      this.inited = true;
    });
  },
  methods: {
    addTableSettings() {
      this.$router.push({
        name: "create-table-settings",
      });
    },
    getParams() {
      const params = {
        page: this.page,
        query: this.query,
      };

      if (this.sortBy) {
        params.sortBy = this.sortBy;
        params.sortType = this.desc ? "desc" : "asc";
      }

      return params;
    },
    async getList() {
      if (this.loading) return null;
      if (this.isLastRequestEmpty) return null;

      this.loading = true;
      return this.$store.dispatch("tablesSettings/getList", this.getParams()).then((items) => {
        if (!items.length < 30) this.isLastRequestEmpty = true;
        this.items = [...this.items, ...items];
        this.loading = false;
      });
    },
    nextPage() {
      if (this.isLastRequestEmpty) return;
      if (!this.inited) return;
      this.page += 1;
      this.getList();
    },
    sort(column) {
      if (this.sortBy === column) {
        this.desc = !this.desc;
      } else {
        this.sortBy = column;
        this.desc = true;
      }
      this.applyFilters();
    },
    applyFilters() {
      this.items = [];
      this.page = 1;
      this.isLastRequestEmpty = false;
      this.loading = false;
      this.getList();
    },
    removeTableSettings(table) {
      this.$store
        .dispatch("tablesSettings/removeTableSettings", {
          id: table.id,
        })
        .then(() => this.applyFilters());
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.tables-settings {
  /deep/ {
    .c-tabs-item-label {
      max-width: 335px;
    }
  }
  .layout-header {
    height: auto;
    min-height: 30px;
  }
  .layout-title {
    margin-bottom: 37px;
  }
  &__tabs {
    margin-bottom: 35px;
  }

  &__actions {
    margin-bottom: 20px;
  }

  &__add {
    display: flex;
    justify-content: flex-end;
  }

  &__search {
    & /deep/ input::placeholder {
      font-style: italic;
    }
  }

  @include onlyStandartMobile {
    .layout-title {
      margin-bottom: 16px;
    }

    &__search {
      margin-bottom: 20px;
    }
    &__actions {
      margin-bottom: 36px;
    }
    &__add {
      display: block;
    }

    &.empty {
      .tables-settings__search {
        display: none;
      }
    }
  }
}


</style>
